export default __webpack_public_path__ + "static/media/back-to-info.cbd236c7.svg";